(() => {
  const setup = (root) => {
    if (root.dataset.lotteryReady === 'true') return;
    root.dataset.lotteryReady = 'true';
    const buttons = [...root.querySelectorAll('[data-spin-button]'), ...document.querySelectorAll('.tn-header-draw')];
    const status = root.querySelector('[data-spin-status]');
    if (!buttons.length || !status) return;
    const setDisabled = (value) => buttons.forEach((button) => { button.disabled = value; });
    const openDraw = () => {
      if (buttons.some((button) => button.disabled)) return;
      setDisabled(true);
      status.textContent = 'Opening the prize draw…';
      let attempts = 0;
      const tryOpen = () => {
        if (window.PopupBoost && typeof window.PopupBoost.open === 'function') {
          try {
            window.PopupBoost.open();
            status.textContent = 'Enter your email in the draw form to continue.';
          } catch (error) {
            status.textContent = 'The draw is temporarily unavailable. Please try again later.';
          }
          setDisabled(false);
          return;
        }
        attempts += 1;
        if (attempts < 30) window.setTimeout(tryOpen, 100);
        else {
          status.textContent = 'The draw is not open yet. Please check back later.';
          setDisabled(false);
        }
      };
      tryOpen();
    };
    buttons.forEach((button) => button.addEventListener('click', (event) => {
      if (button.matches('a')) event.preventDefault();
      openDraw();
    }));
  };
  document.querySelectorAll('[data-lottery-root]').forEach(setup);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-lottery-root]').forEach(setup));
})();